import styled from "styled-components";

export const SiteWrapperHeader = styled.h2`
    && {
        margin-bottom: 24px;
        font-size: 28px;
        line-height: 24px;
    }
`;
